import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "pages";
import DashboardLayout from "layout/dashboard";
import Dashboard from "pages/dashboard/home";
import Login from "pages/login";
import Register from "pages/register";
import ConfirmOTP from "pages/confirm-otp";
import Setup from "pages/setup";
import Setup2 from "pages/setup/two";
import Campaigns from "pages/dashboard/campaigns";
import Notifications from "pages/dashboard/notifications";
import Settings from "pages/dashboard/settings";
import Protected from "layout/protected";
import NeedsVerification from "layout/needsver";
import Answer from "pages/answer/:id";
import Auth from "layout/auth";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route element={<Auth />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>
      <Route element={<Protected />}>
        <Route path="/confirm-otp" element={<ConfirmOTP />} />
        <Route element={<NeedsVerification />}>
          <Route path="/setup" element={<Setup />} />
          <Route path="/setup/two" element={<Setup2 />} />
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route path="home" element={<Dashboard />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="/answer/:id" element={<Answer />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
